export var APPLICANT_PAGE__POINT_TO_SCROLL_ID = 'APPLICANT_PAGE_TITLE';
export var MAIN_FORM_PAGE__LAYOUT_GRID = {
    offset: { md: 1, lg: 2 },
    md: 10,
    lg: 8,
};
